import { render, staticRenderFns } from "./EleFormRadio.vue?vue&type=template&id=4c1792ff&"
import script from "./EleFormRadio.vue?vue&type=script&lang=js&"
export * from "./EleFormRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports